import Vue from 'vue';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import { createPinia, PiniaVuePlugin, setActivePinia } from 'pinia';
import { router } from './router';
import plugins from './plugins';
import App from './App.vue';

fetch('/config.json')
	.then((res) => res.json())
	.then((config) => {
		// set config as global variable:
		window.__APP_CONFIG__ = config;

		// set window title
		document.title = window.__APP_CONFIG__.TITLE;

		const pinia = createPinia();
		setActivePinia(pinia);
		Vue.use(PiniaVuePlugin);

		const { initializeApi, vuetify, i18n, auth, routeTitle, lodash } = plugins;
		initializeApi();
		Vue.use(auth, { router });
		Vue.use(routeTitle, { router, i18n });
		Vue.use(lodash);

		Vue.config.productionTip = import.meta.env.VITE_APP_PRODUCTION === 'true';

		new Vue({
			pinia,
			router,
			vuetify,
			i18n,
			render: (h) => h(App),
		}).$mount('#app');
	})
	.catch((err) => {
		console.error('Failed to load runtime config:', err);
	});
